import React from "react";
import "../App.css";
import { Link, useNavigate } from "react-router-dom";
export default function LandingPage() {
	const router = useNavigate();

	return (
		<div className="landingPageContainer">
			<nav>
				<div className="navHeader">
					<div className="brandMark" aria-hidden="true" />
					<h2>AK Meet</h2>
				</div>
				<div className="navlist">
					<p
						onClick={() => {
							router("/aljk23");
						}}
					>
						Join as Guest
					</p>
					<p
						onClick={() => {
							router("/auth");
						}}
					>
						Register
					</p>
					<div
						onClick={() => {
							router("/auth");
						}}
						role="button"
					>
						{/* role for seo performance */}
						<p>Login</p>
					</div>
				</div>
			</nav>

			<div className="landingMainContainer">
				<div className="landingHero">
					<div className="landingPill">
						<span className="pulseDot" aria-hidden="true" />
						Secure calls • Crisp audio • Instant chat
					</div>
					<h1>
						<span style={{ color: "#F97316" }}>Connect</span> in
						seconds.
					</h1>

					<p className="landingSubtitle">
						A clean, modern video meeting experience with a sleek,
						dark Google-Meet-inspired design that keeps every
						control clear and easy to reach.
					</p>

					<div className="landingCtaRow">
						<div role="button">
							<Link to={"/auth"}>Get Started</Link>
						</div>
						<div
							role="button"
							className="ghostCta"
							onClick={() => router("/aljk23")}
						>
							<span>Try as guest</span>
						</div>
					</div>

					<div className="landingFeatureGrid">
						<div className="featureCard">
							<div className="featureIcon" aria-hidden="true">
								⟠
							</div>
							<h3>One link to join</h3>
							<p>Share a code, join instantly—no clutter.</p>
						</div>
						<div className="featureCard">
							<div className="featureIcon" aria-hidden="true">
								◷
							</div>
							<h3>Meeting history</h3>
							<p>Jump back to recent rooms quickly.</p>
						</div>
						<div className="featureCard">
							<div className="featureIcon" aria-hidden="true">
								✦
							</div>
							<h3>Control focused</h3>
							<p>Mic, camera, chat—always visible.</p>
						</div>
					</div>
				</div>
				<div className="landingArt">
					<img
						className="blobBg"
						src="/ui-blob.svg"
						alt=""
						aria-hidden="true"
					/>
					<div className="deviceFrame">
						<img src="/landingImg.png" alt="AK Meet preview" />
					</div>
				</div>
			</div>
		</div>
	);
}
